import { createSlice } from '@reduxjs/toolkit';
import {
    aguaDulce,
} from '../actions/aguaDulce';


export const AguaDulceReducer = createSlice({
    name: 'aguaDulce',
    initialState: {
        homeSort: {
            sortby: "_id",
            order: "desc",
            limit: 4,
            skip: 0
        },
        loading: false,
        sensores: [],
        current: null
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            // GET ARTICLE
            .addCase(aguaDulce.pending, (state) => { state.loading = true })
            .addCase(aguaDulce.fulfilled, (state, action) => {
                state.loading = false;
                state.current = action.payload
            })
            .addCase(aguaDulce.rejected, (state) => { state.loading = false })
    }
})

export default AguaDulceReducer.reducer;
